import { Card, Header, Space } from '@procurify/ui'

import { SpendTracker } from '@webapp/components/Budgets'
import { ErrorBoundary } from '@webapp/components/ErrorBoundary'
import { useFeatureFlag, useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useSpendTrackerPresenter } from './useSpendTrackerPresenter'

interface ISpendTrackerPresenterProps {
  expenseUuid: string
}

export const SpendTrackerPresenter = ({
  expenseUuid,
}: ISpendTrackerPresenterProps) => {
  const intl = useProcurifyIntl()
  const FT_5817_ENABLE_BUDGETS_REDESIGN = useFeatureFlag(
    'FT_5817_ENABLE_BUDGETS_REDESIGN'
  )

  const {
    data: {
      budgetCategories,
      processedBudgetData,
      primaryCategory,
      secondaryCategory,
      secondaryCategorySpend,
      headquartersTimezone,
      uncategorizedSpend,
    },
    states: { isSpendTrackerEnabled, isSpendTrackerDataLoading },
  } = useSpendTrackerPresenter({ expenseUuid })

  if (!isSpendTrackerEnabled) return null

  return (
    <Card>
      <Card.Content>
        <Space size='large'>
          <Header as='h4'>
            {intl.formatMessage(
              FT_5817_ENABLE_BUDGETS_REDESIGN
                ? messages.budgetTrackerHeader
                : messages.spendTrackerHeader
            )}
          </Header>
          <ErrorBoundary boundaryName='SpendTrackerPresenter'>
            <SpendTracker
              primaryOrganizationName={primaryCategory?.name}
              secondaryOrganizationName={secondaryCategory?.name}
              isLoading={isSpendTrackerDataLoading}
              budgetCategories={budgetCategories}
              departmentalSpend={secondaryCategorySpend}
              processedBudgetData={processedBudgetData}
              uncategorizedSpend={uncategorizedSpend}
              timeZoneTooltip={headquartersTimezone}
            />
          </ErrorBoundary>
        </Space>
      </Card.Content>
    </Card>
  )
}
